import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconTooltipPointDown = ({
  width = 12,
  height = 6,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 12 6'
      {...props}
    >
      <path
        d='M6 6H0L4.58579 1.41421C5.36683 0.633165 6.63316 0.633165 7.41421 1.41421L12 6H6Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconTooltipPointDown)
